var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    height: "200px",
    width: "200px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M283.826,0H50.091C22.473,0,0.005,22.467,0.005,50.086v166.953c0,27.619,22.467,50.086,50.086,50.086h16.695v50.086 c0,14.843,18.005,22.298,28.499,11.804l61.89-61.89h126.65c27.618,0,50.086-22.467,50.086-50.086V50.086 C333.912,22.467,311.444,0,283.826,0z M100.177,150.258c-9.22,0-16.695-7.475-16.695-16.695s7.475-16.695,16.695-16.695 c9.22,0,16.695,7.475,16.695,16.695S109.397,150.258,100.177,150.258z M166.958,150.258c-9.22,0-16.695-7.475-16.695-16.695 s7.475-16.695,16.695-16.695c9.22,0,16.695,7.475,16.695,16.695S176.179,150.258,166.958,150.258z M233.74,150.258 c-9.22,0-16.695-7.475-16.695-16.695s7.475-16.695,16.695-16.695s16.695,7.475,16.695,16.695S242.96,150.258,233.74,150.258z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M461.909,178.083h-94.607v38.956c0,43.807-33.927,79.815-76.882,83.192c2.805,2.986,4.536,6.994,4.536,11.415 c0,9.22-7.475,16.695-16.695,16.695s-16.695-7.475-16.695-16.695c0-4.282,1.626-8.175,4.276-11.13h-87.753v94.607 c0,27.603,22.483,50.086,50.086,50.086h126.662l61.883,61.884c10.55,10.548,28.494,2.927,28.494-11.798v-50.086h16.695 c27.603,0,50.086-22.483,50.086-50.086V228.169C511.995,200.567,489.511,178.083,461.909,178.083z M345.042,328.341 c-9.22,0-16.695-7.475-16.695-16.695c0-9.22,7.475-16.695,16.695-16.695s16.695,7.475,16.695,16.695 C361.737,320.866,354.262,328.341,345.042,328.341z M411.823,328.341c-9.22,0-16.695-7.475-16.695-16.695 c0-9.22,7.475-16.695,16.695-16.695s16.695,7.475,16.695,16.695C428.518,320.866,421.043,328.341,411.823,328.341z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.82551be5391d87d7f998597de6511424.svg";
export { ForwardRef as ReactComponent };